import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { CONTACTS_FILTER_APPLIED, CONTACTS_USER_CLICKED, CONTACTS_USER_OPENED, CONTACTS_USER_INFO_EDITED, CONTACTS_REFRESHED, CONTACTS_USER_REFRESHED, CONTACTS_USER_TICKET_OPENED, CONTACTS_USER_TICKET_HISTORY_EXPORTED, CONTACTS_USER_TICKET_HISTORY_COPIED, ANALYTICS_CONTACTS_DATE_CHANGED, CONTACTS_USER_TEST_TOGGLE, CONTACTS_USER_TICKET_HISTORY_NOT_FOUND_THREAD, TICKET_UNLINKED, TICKET_LINK_MODAL_OPEN, TICKET_HISTORY_THREAD_VIEWED, TICKET_HISTORY_DETAILS_EXPANDED, } from './UsersSegmentEvents';
export class UsersSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackFilterApplied(payload, success) {
        this.trackEvent(CONTACTS_FILTER_APPLIED, payload, success);
    }
    trackUserClicked(payload, success) {
        this.trackEvent(CONTACTS_USER_CLICKED, payload, success);
    }
    trackUserOpened(payload, success) {
        this.trackEvent(CONTACTS_USER_OPENED, payload, success);
    }
    trackUserInfoEdited(payload, success) {
        this.trackEvent(CONTACTS_USER_INFO_EDITED, payload, success);
    }
    trackRefreshed(payload, success) {
        this.trackEvent(CONTACTS_REFRESHED, payload, success);
    }
    trackAnalyticsContactsDateChanged(payload, success) {
        this.trackEvent(ANALYTICS_CONTACTS_DATE_CHANGED, payload, success);
    }
    tracUserRefreshed(payload, success) {
        this.trackEvent(CONTACTS_USER_REFRESHED, payload, success);
    }
    trackUserTicketOpened(payload, success) {
        this.trackEvent(CONTACTS_USER_TICKET_OPENED, payload, success);
    }
    trackUserTicketHistoryExported({ success }) {
        this.trackEvent(CONTACTS_USER_TICKET_HISTORY_EXPORTED, undefined, success);
    }
    trackUserTicketHistoryCopied(payload, success) {
        this.trackEvent(CONTACTS_USER_TICKET_HISTORY_COPIED, payload, success);
    }
    trackUserTestToggle(payload, success) {
        this.trackEvent(CONTACTS_USER_TEST_TOGGLE, payload, success);
    }
    trackUserTicketHistoryNotFoundOnThreadMessages(payload, success) {
        this.trackEvent(CONTACTS_USER_TICKET_HISTORY_NOT_FOUND_THREAD, payload, success);
    }
    trackUndoTicketLink(payload) {
        this.trackEvent(TICKET_UNLINKED, payload);
    }
    trackTicketLinkModalOpen() {
        this.trackEvent(TICKET_LINK_MODAL_OPEN);
    }
    trackTicketHistoryThreadViewed() {
        this.trackEvent(TICKET_HISTORY_THREAD_VIEWED);
    }
    trackTicketHistoryDetailsExpanded() {
        this.trackEvent(TICKET_HISTORY_DETAILS_EXPANDED);
    }
    trackEvent(event, payload, success) {
        this.SegmentService.createBotTrack(event, this.application, { ...payload, Status: this.eventStatus(success) });
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
UsersSegmentService.$inject = ['SegmentService'];
